import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { waitForData } from '@ifit/native-webview-interface';

import { FeatureFlag, FeatureFlags, WaitForDataResponse } from '../../types';
import { IState } from '../../state-management/types';

/**
 * App-wide store of feature flags where flags are progressively added to the store as components
 * request different flags from native.
 */
export const useFeatureFlags = (flags: FeatureFlag[]): Partial<FeatureFlags> => {
  const configuredFeatureFlags: Partial<FeatureFlags> = useSelector((state: IState) => state.featureFlags) ?? {};
  const [featureFlags, setFeatureFlags] = useState(configuredFeatureFlags);

  const [featureFlagsLoading, setFeatureFlagsLoading] = useState(Object.keys(configuredFeatureFlags).length === 0);

  useEffect(() => {
    if (featureFlagsLoading && flags.length > 0) {
      (async () => {
        const localData: WaitForDataResponse | null = await (waitForData(flags) as Promise<WaitForDataResponse>);

        if (localData != null) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          const { methodName, echo, errors, ...localFeatureFlagData } = localData;

          setFeatureFlags({ ...featureFlags, ...localFeatureFlagData });
        }
        setFeatureFlagsLoading(false);
      })();
    }
  }, [featureFlags, featureFlagsLoading, flags]);

  return featureFlags;
};
